import type { TurboModule } from 'react-native/Libraries/TurboModule/RCTExport';
import { TurboModuleRegistry } from 'react-native';

export interface Spec extends TurboModule {
    // HanselRn methods
    getInteractionMaps(callback: (maps: Object) => void): void;
    onBackButtonPressed(): boolean;
    onSetScreen(screenName: string): void;
    onUnsetScreen(): void;
    showToast(text: string, longDuration: boolean): void;
    setTypeface(fontFileName: string): void;
    setAppFont(fontName: string): void;
    setNativeID(): void;

    // HanselUser methods
    putStringAttribute(key: string, value: string): void;
    putDoubleAttribute(key: string, value: number): void;
    putBooleanAttribute(key: string, value: boolean): void;
    putPrivateStringAttribute(key: string, value: string): void;
    putPrivateDoubleAttribute(key: string, value: number): void;
    putPrivateBooleanAttribute(key: string, value: boolean): void;
    setUserId(userId: string): void;
    clearAttribute(key: string): void;
    clear(): void;

    // HanselConfigs methods
    getString(configName: string, fallbackValue: string, callback: (value: string) => void): void;
    getBoolean(configName: string, fallbackValue: boolean, callback: (value: boolean) => void): void;
    getDouble(configName: string, fallbackValue: number, callback: (value: number) => void): void;
    getList(configName: string, defaultValue: Object[], callback: (value: Object[]) => void): void;
    getJSONArray(configName: string, defaultValue: Object[], callback: (value: Object[]) => void): void;
    getJSONObject(configName: string, defaultValue: Object, callback: (value: Object) => void): void;

    // HanselTracker methods
    logEvent(eventName: string, vendor: string, hanselProperties: Object, callback: (result: Object) => void): void;
    getHanselData(eventName: string, vendor: string, properties: Object, callback: (result: Object) => void): void;
    isUsedInMap(event: string, vendor: string, properties: Object, callback: (result: boolean) => void): void;
    registerHanselTrackerListener(): void;
    registerHanselActionListenerWithActionName(actionName: string): void;
    registerHanselDeeplinkListener(): void;
    deRegisterListener(): void;
    removeHanselActionListenerForAction(actionName: string): void;

    // HanselLogs methods
    e(tag: string, message: string): void;

    // Event listeners (required for TurboModule)
    addListener(eventName: string): void;
    removeListeners(count: number): void;
}

export default TurboModuleRegistry.getEnforcing<Spec>('SmartechNudges');
